import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../../data/landing';
import { spring } from '../../utils/motion';
export function FaqList() {
  const [open, setOpen] = useState<number | null>(0);
  return <ul className="divide-y divide-line border-y border-line" data-id="element-330" data-mp="scqo31t4evj5">
      {faqs.map((f, i) => {
      const isOpen = open === i;
      return <li key={f.q} data-id="element-331" data-mp="1pz7j20edsx1q" data-mpi={i}>
            <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 py-5 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-332" data-mp="1l0wb5v7ncwm5">
              <span className="text-lg font-bold" data-id="element-333" data-mp="4n5snjfs65sz">{f.q}</span>
              <motion.span animate={{
            rotate: isOpen ? 45 : 0
          }} transition={spring.snappy} className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-surface-2" data-id="element-334" data-mp="4kjkpioz9oa8">
                <PlusIcon className="h-5 w-5" data-id="element-335" data-mp="n8n74mu3muqm" />
              </motion.span>
            </button>
            <AnimatePresence initial={false} data-id="element-336" data-mp="s53wtlgy5h5t">
              {isOpen && <motion.p initial={{
            opacity: 0,
            y: -6
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            transition: {
              duration: 0.1
            }
          }} transition={{
            duration: 0.18,
            ease: 'easeOut'
          }} className="max-w-[65ch] pb-5 text-[16px] leading-relaxed text-ink-2" data-id="element-337" data-mp="d9xogrudp69b">
                  {f.a}
                </motion.p>}
            </AnimatePresence>
          </li>;
    })}
    </ul>;
}